// extracted by mini-css-extract-plugin
export default {"toggle-items":"cf-toggle-items","toggle-items_big":"cf-toggle-items_big","toggle-items__item":"cf-toggle-items__item","toggle-items__item_active":"cf-toggle-items__item_active"};